const NotificationIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.00065 1.33301C5.03011 1.33301 2.61924 3.72735 2.61922 6.68432C2.61916 7.37211 2.5729 7.89123 2.25579 8.3578C2.21169 8.42174 2.15318 8.50183 2.08925 8.58934C1.97821 8.74131 1.85083 8.91567 1.75421 9.06668C1.58367 9.33321 1.41705 9.65462 1.35977 10.0291C1.17289 11.251 2.03436 12.0421 2.89229 12.3966C5.91409 13.6452 10.0872 13.6452 13.109 12.3966C13.9669 12.0421 14.8284 11.251 14.6415 10.0291C14.5843 9.65462 14.4176 9.33321 14.2471 9.06668C14.1505 8.91568 14.0231 8.74133 13.9121 8.58936C13.8482 8.50187 13.7896 8.42179 13.7455 8.35785C13.4284 7.89126 13.3821 7.3722 13.3821 6.68436C13.3821 3.72737 10.9712 1.33301 8.00065 1.33301Z"
        fill="#D1D5DB"
      />
      <path
        d="M7.99963 15.6648C8.6798 15.6648 9.31679 15.4706 9.85238 15.1337C10.3277 14.8348 10.5654 14.6853 10.4822 14.4368C10.3991 14.1883 10.0711 14.2162 9.41515 14.2718C8.47703 14.3514 7.52223 14.3514 6.5841 14.2718C5.92816 14.2162 5.60018 14.1883 5.51701 14.4368C5.43383 14.6853 5.67151 14.8348 6.14688 15.1337C6.68247 15.4706 7.31945 15.6648 7.99963 15.6648Z"
        fill="#D1D5DB"
      />
    </svg>
  );
};

export default NotificationIcon;
